<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">{{ eventId ? "Edit" : "Add" }} Comment for {{ fullName }}</h3>
      <base-form ref="form" v-model="isFormValid" class="tw-mt-4">
        <base-textarea label="Comment" placeholder="Enter comment" v-model="comment" required />
      </base-form>
      <div class="tw-flex tw-justify-between">
        <div v-if="eventId">
          <base-button @click="deleteComment" :loading="isDeleting" color="red" v-if="showConfirmDelete">
            Confirm Delete
          </base-button>
          <base-button @click="showConfirmDelete = true" color="red" type="flat" v-else>
            Delete
          </base-button>
        </div>
        <div v-else />
        <div class="sm:tw-flex sm:tw-flex-row-reverse">
          <base-button @click="send" :loading="isLoading" :disabled="!isFormValid" class="tw-w-auto tw-ml-3">
            {{ eventId ? "Update" : "Send" }}
          </base-button>
          <base-button @click="hide" type="flat" class="tw-w-auto w-mt-0">
            Cancel
          </base-button>
        </div>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
export default {
  props: {
    businessId: String,
    userId: String,
    fullName: String,
  },
  data() {
    return {
      isLoading: false,
      isDeleting: false,
      isFormValid: true,
      eventId: "",
      comment: "",
      showConfirmDelete: false,
    };
  },
  methods: {
    show(event) {
      this.$refs.modal.show();
      this.$refs.form.reset();
      this.eventId = event.eventId;
      this.comment = event.label;
      this.showConfirmDelete = false;
    },
    hide() {
      this.$refs.modal.hide();
    },
    async send() {
      if (!this.$refs.form.validate()) return;

      try {
        this.isLoading = true;

        if (this.eventId) {
          await this.$axios.put(`/businesses/${this.businessId}/members/${this.userId}/comments/${this.eventId}`, {
            comment: this.comment,
          });
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Comment Updated", message: "Your comment was updated successfully" });
        } else {
          await this.$axios.post(`/businesses/${this.businessId}/members/${this.userId}/comments`, {
            comment: this.comment,
          });
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Comment Added", message: "Your comment was added successfully" });
        }
        this.$emit("refresh");
        this.hide();
      } finally {
        this.isLoading = false;
      }
    },
    async deleteComment() {
      try {
        this.isDeleting = true;

        await this.$axios.delete(`/businesses/${this.businessId}/members/${this.userId}/comments/${this.eventId}`);
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Comment Deleted", message: "Your comment was deleted successfully" });
        this.$emit("refresh");
        this.hide();
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
